// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading__mjdu2","popup":"styles_popup__2gDAD","controls":"styles_controls__3pkKG","button":"styles_button__36Mqr"};